//src/pages/AboutPage.js
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import TopBanner from "../components/TopBanner";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { getAboutPageSettings } from "../services/homepage.api";

function AboutPage() {
  const { lang } = useContext(LanguageContext);
  const [settings, setSettings] = useState(null);
const [loading, setLoading] = useState(true);

  const IMAGE_BASE =
    process.env.REACT_APP_API_URL?.replace(/\/api$/, "") ||
    window.location.origin;

  const resolveImage = (url) => {
    if (!url) return "/images/placeholder-product.jpg";
    if (url.startsWith("http")) return url;
    return IMAGE_BASE + url;
  };

  useEffect(() => {
  let mounted = true;

  setLoading(true);

  getAboutPageSettings()
    .then((data) => {
      if (mounted) setSettings(data);
    })
    .catch(() => {
      if (mounted) setSettings(null);
    })
    .finally(() => {
      if (mounted) setLoading(false);
    });

  return () => {
    mounted = false;
  };
}, []);

  const TEXT = {
    EN: {
      mainPage: "Main page",
      about: "About us",
      title: "About us",
      hi: "Hi Dear!",
      p1:
        "We have been developing ETIKA in Lebanon with women’s boutiques and wholesale fashion needs in mind.",
      p2:
        "We are preparing stylish, fashionable and carefully selected pieces for every woman who wants to feel confident and elegant.",
      styling: "Our stylings primarily mean:",
      newest: "newest trends",
      comfort: "comfort",
      quality: "quality",
      founder:
        "The founder of ETIKA created the brand with women’s fashion and boutique needs in mind.",
      mottoPrefix: "Motto:",
      motto: "Our desire is to make all women happy!",
      inspired:
        "Get inspired to wear original and fashionable stylings.",
      knowUs: "Do you want to get to know us better?",
      social: "Visit our social media",
    },
    AR: {
      mainPage: "الصفحة الرئيسية",
      about: "من نحن",
      title: "من نحن",
      hi: "أهلاً بك!",
      p1:
        "نحن نعمل على تطوير ETIKA في لبنان مع الاهتمام بموضة النساء واحتياجات المتاجر.",
      p2:
        "نختار قطعاً أنيقة وعصرية بعناية لكل امرأة ترغب بالشعور بالثقة والتميز.",
      styling: "ستايلاتنا تعني بشكل أساسي:",
      newest: "أحدث الصيحات",
      comfort: "الراحة",
      quality: "الجودة",
      founder:
        "تم إنشاء ETIKA مع وضع موضة النساء واحتياجات المتاجر في الاعتبار.",
      mottoPrefix: "شعارنا:",
      motto: "رغبتنا هي أن نجعل كل النساء سعيدات!",
      inspired:
        "استلهمي إطلالات أصلية وعصرية تناسبك.",
      knowUs: "هل تريدين التعرف علينا أكثر؟",
      social: "تابعينا على وسائل التواصل",
    },
  }[lang];

    const aboutText = {
    hi:
      lang === "AR"
        ? settings?.hi_ar || TEXT.hi
        : settings?.hi_en || TEXT.hi,

    paragraph1:
      lang === "AR"
        ? settings?.paragraph_1_ar || TEXT.p1
        : settings?.paragraph_1_en || TEXT.p1,

    paragraph2:
      lang === "AR"
        ? settings?.paragraph_2_ar || TEXT.p2
        : settings?.paragraph_2_en || TEXT.p2,

    stylingTitle:
      lang === "AR"
        ? settings?.styling_title_ar || TEXT.styling
        : settings?.styling_title_en || TEXT.styling,

    bullet1:
      lang === "AR"
        ? settings?.bullet_1_ar || TEXT.newest
        : settings?.bullet_1_en || TEXT.newest,

    bullet2:
      lang === "AR"
        ? settings?.bullet_2_ar || TEXT.comfort
        : settings?.bullet_2_en || TEXT.comfort,

    bullet3:
      lang === "AR"
        ? settings?.bullet_3_ar || TEXT.quality
        : settings?.bullet_3_en || TEXT.quality,

    founder:
      lang === "AR"
        ? settings?.founder_text_ar || TEXT.founder
        : settings?.founder_text_en || TEXT.founder,

    mottoPrefix:
      lang === "AR"
        ? settings?.motto_prefix_ar || TEXT.mottoPrefix
        : settings?.motto_prefix_en || TEXT.mottoPrefix,

    motto:
      lang === "AR"
        ? settings?.motto_text_ar || TEXT.motto
        : settings?.motto_text_en || TEXT.motto,
  };

  const counters = [
    {
      value: settings?.new_products_value || "500+",
      label:
        lang === "AR"
          ? settings?.new_products_label_ar || "منتج جديد شهرياً"
          : settings?.new_products_label_en || "new products per month",
    },
    {
      value: settings?.completion_time_value || "24 h",
      label:
        lang === "AR"
          ? settings?.completion_time_label_ar || "مدة تجهيز الطلب"
          : settings?.completion_time_label_en || "Order completion time",
    },
    {
      value: settings?.market_value || "9 years",
      label:
        lang === "AR"
          ? settings?.market_label_ar || "في السوق"
          : settings?.market_label_en || "on the market",
    },
  ];

  if (loading) {
  return (
    <div
      className="w-full min-h-screen bg-white overflow-x-hidden"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      <TopBanner />
      <MainHeader />

      <main className="bg-white px-4 md:px-8 md:pt-[175px]">
        <div className="h-4 w-[180px] bg-gray-200 animate-pulse rounded mb-8" />

        <div className="max-w-7xl mx-auto pb-12">
          <section className="grid md:grid-cols-[1fr_1fr] gap-8 md:gap-12 items-start">
            <div>
              <div className="h-10 w-[220px] bg-gray-200 animate-pulse rounded mb-6" />
              <div className="h-6 w-[140px] bg-gray-200 animate-pulse rounded mb-7" />

              <div className="space-y-4">
                <div className="h-5 w-full bg-gray-200 animate-pulse rounded" />
                <div className="h-5 w-[92%] bg-gray-200 animate-pulse rounded" />
                <div className="h-5 w-[85%] bg-gray-200 animate-pulse rounded" />
                <div className="h-5 w-[70%] bg-gray-200 animate-pulse rounded" />
              </div>

              <div className="mt-8 space-y-4">
                <div className="h-5 w-[210px] bg-gray-200 animate-pulse rounded" />
                <div className="h-5 w-[160px] bg-gray-200 animate-pulse rounded" />
                <div className="h-5 w-[150px] bg-gray-200 animate-pulse rounded" />
              </div>
            </div>

            <div className="w-full aspect-[4/3] bg-gray-200 animate-pulse" />
          </section>

          <section className="grid md:grid-cols-2 gap-8 mt-10 md:mt-14">
            <div className="w-full aspect-[4/3] bg-gray-200 animate-pulse" />
            <div className="w-full aspect-[4/3] bg-gray-200 animate-pulse" />
          </section>

          <section className="mt-12 md:mt-16 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
            {[1, 2, 3].map((i) => (
              <div key={i} className="text-center">
                <div className="mx-auto h-[70px] w-[150px] bg-gray-200 animate-pulse rounded-2xl" />
                <div className="mx-auto mt-4 h-5 w-[180px] bg-gray-200 animate-pulse rounded" />
              </div>
            ))}
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

  return (
    <div
      className="w-full min-h-screen bg-white overflow-x-hidden"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      <TopBanner />
      <MainHeader />

      <main className="bg-white px-4 md:px-8 md:pt-[175px]">
        {/* BREADCRUMB */}
        <div className="text-[12px] md:text-sm text-gray-900 mb-8">
          <button
            type="button"
            onClick={() => {
              window.location.href = "/";
            }}
            className="hover:text-black hover:underline"
          >
            {TEXT.mainPage}
          </button>

          <span className="mx-2">›</span>

          <span>{TEXT.about}</span>
        </div>

        <div className="max-w-7xl mx-auto pb-12">
          {/* TOP DESKTOP GRID */}
          <section className="grid md:grid-cols-[1fr_1fr] gap-8 md:gap-12 items-start">
            <div className={lang === "AR" ? "text-right" : "text-left"}>
              <h1 className="text-[34px] md:text-[42px] font-normal text-black mb-5">
                {TEXT.title}
              </h1>

              <p className="text-[18px] md:text-[20px] text-gray-900 mb-6">
                {aboutText.hi}
              </p>

              <div className="space-y-6 text-[18px] md:text-[20px] leading-8 text-gray-900">
                <p>{aboutText.paragraph1}</p>
<p>{aboutText.paragraph2}</p>

                <div>
                  <p className="mb-4">{aboutText.stylingTitle}</p>

                  <ul className="list-disc list-inside space-y-4">
                    <li>{aboutText.bullet1}</li>
<li>{aboutText.bullet2}</li>
<li>{aboutText.bullet3}</li>
                  </ul>
                </div>

                <p>
                  {aboutText.founder}
<br />
{aboutText.mottoPrefix}{" "}
<strong>{aboutText.motto}</strong>
                </p>
              </div>
            </div>

            <img
              src={resolveImage(settings?.image_1)}
              alt="About ETIKA"
              className="w-full aspect-[4/3] object-cover bg-gray-100"
            />
          </section>

          {/* TWO IMAGES */}
          <section className="grid md:grid-cols-2 gap-8 mt-10 md:mt-14">
            <img
              src={resolveImage(settings?.image_2)}
              alt="ETIKA collection"
              className="w-full aspect-[4/3] object-cover bg-gray-100"
            />

            <img
              src={resolveImage(settings?.image_3)}
              alt="ETIKA styling"
              className="w-full aspect-[4/3] object-cover bg-gray-100"
            />
          </section>

          {/* INSPIRED TEXT */}
          <p className="mt-12 md:mt-14 text-[18px] md:text-[20px] leading-8 text-gray-900">
            {TEXT.inspired}
          </p>

          {/* COUNTERS */}
          <section className="mt-12 md:mt-16 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 text-center">
            {counters.map((item) => (
              <div key={item.label}>
                <div className="inline-flex items-center justify-center px-7 py-4 bg-black text-white rounded-2xl text-[34px] md:text-[38px] leading-none tracking-[0.08em]">
                  {item.value}
                </div>

                <p className="mt-4 text-[18px] md:text-[20px] text-gray-900">
                  {item.label}
                </p>
              </div>
            ))}
          </section>

          {/* BOTTOM */}
          <section className="mt-16 md:mt-20 text-[18px] md:text-[20px] leading-8 text-gray-900">
            <p>{TEXT.knowUs}</p>
            <p className="mt-4">{TEXT.social}</p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default AboutPage;